import React from 'react';
import '../styles/Root.css';
import '../styles/InformationsLegales.css';


const InformationsLegales = () => {
  return (
    <>
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-7TQ0QQRVYE"></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-7TQ0QQRVYE');
          `,
        }}
      />

      <section className="hero">
        <h1>Informations Légales</h1>
        <p>Mentions légales et conditions d'utilisation du site</p>
      </section>

      <main className="grid-container">
        <div className="legal-card renseignements">
          <h2>1. Renseignements juridiques</h2>
          <p>
            Raison sociale: Association des amis du musée des Troupes de marine (AAMTDM)<br />
            Adresse du siège social : 240 Avenue du musée des Troupes de marine 83600 Fréjus<br />
            Adresse postale : AAMTDM BP 10 - 83601 Fréjus CEDEX<br />
            Numéro de téléphone : 0494407605<br />
            Adresse de courrier électronique : amisdumusee@wanadoo.fr<br />
            Forme juridique de la société: Association type Loi 1901<br />
            Montant du capital social: 0 €<br />
            Numéro SIREN de l'association: 435 219 266 <br />
            Directeur de la publication et responsable de la rédaction: Jean Pierre DUTARTRE
          </p>
        </div>

        <div className="legal-card droits">
          <h2>2. Droits d'auteur & Droits de reproduction</h2>
          <p>L'ensemble des contenus de ce site relève de la législation française et internationale sur les droits d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés. La reproduction de tout ou partie du site, quelles qu'en soient la forme et la destination est formellement interdite, sauf autorisation expresse de l'Association des Amis du Musée.</p>
        </div>

        <div className="legal-card photos">
          <h2>3. Photos – Visuels</h2>
          <p>Les photographies et visuels de ce site sont la propriété de l'Association des Amis du Musée et du Musée.</p>
        </div>

        <div className="legal-card liens">
          <h2>4. Liens</h2>
          <p>Ce site propose des liens vers d'autres sites. La consultation de ces sites ainsi que la collecte et l'utilisation de données personnelles sur ces sites sont soumises aux conditions d'utilisation et aux politiques de protection des données personnelles des sites consultés.</p>
        </div>

        <div className="legal-card modifications">
          <h2 style={{ color: 'white' }}>5. Modifications</h2>
          <p>L'Association des amis du Musée se réserve le droit de modifier ou, de façon plus générale, d'actualiser ce site internet à tout moment et sans préavis.</p>
        </div>

        <div className="legal-card conception">
          <h2>6. Conception – Développement – Maintenance</h2>
          <p>Ce site internet a été concu par l'Association des Amis du Musée des Troupes de Marine, en lien avec le Musée.</p>
          <p>Son développement, son hébergement et sa maintenance sont assurés par la société Back2Growth SARL: 21 Chemin du Vallon des Vaux, 06800 Cagnes-sur-Mer, 0751272623.</p>
        </div>

        <div className="legal-card contact">
          <h2 style={{ color: 'white' }}>7. Contact technique</h2>
          <p>Les problèmes d'ordre techniques peuvent être signalés auprès de : alexandre@back2growth.fr</p>
          <p>Si vous souhaitez signaler un dysfonctionnement, nous vous demandons de bien vouloir nous fournir le plus possible de détails sur votre configuration (type d'ordinateur, navigateur et version) et sur le message d'erreur éventuellement reçu</p>
        </div>

        <div className="legal-card informations">
          <h2>8. Informations nominatives</h2>
          <p>Les informations recueillies auprès des personnes par le biais des différents formulaires (d'inscription, d'information, etc…) ne sauraient être utilisées à usage commercial ou pour un quelconque démarchage. Toutefois, tel que l'exige la loi n° 78-17 du 6 janvier 1978, nous vous informons que vos réponses sont facultatives, que votre défaut de réponse n'entraînera aucune conséquence particulière.</p>
          <p>Les informations envoyées sont ou bien destinées à l'Association des Amis du Musée, ou bien au Musée des Troupes de Marine, ou bien encore au CHETOM, qui traiteront vos demandes.</p>
          <p>Vous avez un droit total d'accès, de modification, de rectification et de suppression aux informations nominatives vous concernant. Pour l'exercer, adressez-vous à alexandre@back2growth.fr</p>
        </div>
      </main>
    </>
  );
};

export default InformationsLegales;
